import { Swiper } from 'swiper';
import 'swiper/css';

export default function () {
    if (document.querySelector('.text-and-items__swiper')) {
        initSwiper();
    }
}

const initSwiper = () => {
    const swiper = new Swiper('.text-and-items__swiper', {
        slidesPerView: 1.2,
        spaceBetween: 16,
        grabCursor: true,
        breakpoints: {
            440: {
                slidesPerView: 1.8,
            },
            768: {
                slidesPerView: 2.2,
                spaceBetween: 16,
            },
            1024: {
                grabCursor: false,
                enabled: false,
                slidesPerView: 3,
                spaceBetween: 16,
            },
        },
    });
};
